import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import styles from './customerBillingAddress.module.css';
import api from '../../utils/api';
import { useNavigate } from 'react-router-dom';
import { deleteCustomerdata, setAddress, setCustomerData } from '../../redux/customerSlice';
import { toast } from 'react-toastify';
import { Country, State } from "country-state-city";

const CustomerBillingAddress = () => {
    const { customerData, sameAddress } = useSelector((state) => state.customer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [billingStates, setBillingStates] = useState([]);
    const [shippingStates, setShippingStates] = useState([]);
    const { appearences, loading } = useSelector((state) => state.appearences)
    const [countries, setCountries] = useState([]);


    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList);
    }, []);

    const validationSchema = Yup.object({
        billingAddress: Yup.object().shape({
            factoryUnits: Yup.string().required('Required'),
            streetAddress: Yup.string().required('Required'),
            country: Yup.string().required('Required'),
            state: Yup.string().required('Required'),
            zipCode: Yup.string().required('Required'),
        }),
        shippingAddress: Yup.object().shape({
            factoryUnits: Yup.string().required('Required'),
            streetAddress: Yup.string().required('Required'),
            country: Yup.string().required('Required'),
            state: Yup.string().required('Required'),
            zipCode: Yup.string().required('Required'),
        }),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            billingAddress: {
                factoryUnits: customerData.billingAddress?.factoryUnits || '',
                streetAddress: customerData.billingAddress?.streetAddress || '',
                country: customerData.billingAddress?.country || '',
                state: customerData.billingAddress?.state || '',
                zipCode: customerData.billingAddress?.zipCode || '',
            },
            shippingAddress: {
                factoryUnits: sameAddress ? customerData.billingAddress?.factoryUnits : customerData.shippingAddress?.factoryUnits || '',
                streetAddress: sameAddress ? customerData.billingAddress?.streetAddress : customerData.shippingAddress?.streetAddress || '',
                country: sameAddress ? customerData.billingAddress?.country : customerData.shippingAddress?.country || '',
                state: sameAddress ? customerData.billingAddress?.state : customerData.shippingAddress?.state || '',
                zipCode: sameAddress ? customerData.billingAddress?.zipCode : customerData.shippingAddress?.zipCode || '',
            },
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {

            const mergedData = { ...customerData, ...values };

            // The first step (name, email, password) must be present; it is lost if the
            // page was opened directly or the session was cleared.
            if (!mergedData.fullName || !mergedData.email || !mergedData.password) {
                toast.error('Please fill in your name, email and password first');
                navigate('/customerRegn');
                return;
            }

            try {
                const response = await api.customerRegister(mergedData);

                toast.success(response?.data?.data?.message || 'Registration successful. Your account is pending admin approval.')
                dispatch(deleteCustomerdata())
                navigate('/login')
            } catch (error) {
                // console.error('Error registering:', error);
                toast.error(error?.response?.data?.message || 'Something went wrong')
            }
        },
    });

    useEffect(() => {

        const billing = formik.values.billingAddress
        if (billing.country) {
            const selectedCountry = countries.find(
                (country) => country.name === billing.country
            );
            if (selectedCountry) {
                const states = State.getStatesOfCountry(selectedCountry.isoCode);
                setBillingStates((prevStates) => {
                    let updatedStates = [...prevStates];
                    updatedStates = states;
                    return updatedStates;
                });
            }
        }

        const address = formik.values.shippingAddress
        if (address.country) {
            const selectedCountry = countries.find(
                (country) => country.name === address.country
            );
            if (selectedCountry) {
                const states = State.getStatesOfCountry(selectedCountry.isoCode);
                setShippingStates((prevStates) => {
                    let updatedStates = [...prevStates];
                    updatedStates = states;
                    return updatedStates;
                });
            }
        }
    }, [formik.values.billingAddress,formik.values.shippingAddress, countries]);

    useEffect(() => {
        if (!sameAddress) {
            formik.setFieldValue("shippingAddress.factoryUnits", "")
            formik.setFieldValue("shippingAddress.streetAddress", "")
            formik.setFieldValue("shippingAddress.country", "")
            formik.setFieldValue("shippingAddress.state", "")
            formik.setFieldValue("shippingAddress.zipCode", "")
        }
    }, [sameAddress])

    useEffect(() => {
        dispatch(setCustomerData(formik.values));
    }, [formik.values, dispatch]);

    const handleBillingCountryChange = (countryName) => {
        const selectedCountry = countries.find((country) => country?.name === countryName);
        if (selectedCountry) {
            const stateList = State.getStatesOfCountry(selectedCountry.isoCode);
            setBillingStates(stateList);
            formik.setFieldValue("billingAddress.country", countryName);
            formik.setFieldValue("billingAddress.state", ""); // Reset state
        }
    };


    const handleShippingCountryChange = (countryName) => {
        const selectedCountry = countries.find((country) => country?.name === countryName);
        if (selectedCountry) {
            const stateList = State.getStatesOfCountry(selectedCountry.isoCode);
            setShippingStates(stateList);
            formik.setFieldValue("shippingAddress.country", countryName);
            formik.setFieldValue("shippingAddress.state", ""); // Reset state
        }
    };





    return (
        <>
            <div className={styles.loginCol1} onClick={() => navigate('/')}>
                <img src='/assets/logo.jpg' alt="Logo" />
            </div>
            <div className={styles.loginContainer}
                style={{
                    backgroundImage: `url(${appearences?.loginBanner?.image || '/assets/login.png'})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundAttachment: "fixed",
                    backgroundSize: 'cover',
                    // height: '100vh',
                }}
            >
                <div className={styles.loginInner}>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>
                            <div className={styles.loginCardHead}>
                                <h3>Customer Registration</h3>
                            </div>
                            <div className={styles.hrseparator}></div>

                            <div className={styles.loginContent}>
                                <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                    <p>Billing Address</p>
                                    <div className={styles.loginFormRow1}>
                                        <div className={styles.loginInputGroup}>
                                            <label>Factory Units</label>
                                            <select
                                                name="billingAddress.factoryUnits"
                                                className={styles.selectField}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.billingAddress.factoryUnits}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>
                                            {formik.touched.billingAddress?.factoryUnits && formik.errors.billingAddress?.factoryUnits ? (
                                                <div className={styles.error}>{formik.errors.billingAddress.factoryUnits}</div>
                                            ) : null}
                                        </div>

                                        <div className={styles.loginInputGroup2}>
                                            <label>Street Address</label>
                                            <input
                                                type="text"
                                                name="billingAddress.streetAddress"
                                                placeholder="Enter street address"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.billingAddress.streetAddress}
                                            />
                                            {formik.touched.billingAddress?.streetAddress && formik.errors.billingAddress?.streetAddress ? (
                                                <div className={styles.error}>{formik.errors.billingAddress.streetAddress}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className={styles.loginFormRow2}>
                                        <div className={styles.loginInputGroup}>
                                            <label>Country / Region</label>
                                            <select
                                                name="billingAddress.country"
                                                className={styles.selectField}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.billingAddress.country}
                                                onChange={(e) => handleBillingCountryChange(e.target.value)}
                                            >
                                                <option value="">Select</option>{countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {formik.touched.billingAddress?.country && formik.errors.billingAddress?.country ? (
                                                <div className={styles.error}>{formik.errors.billingAddress.country}</div>
                                            ) : null}
                                        </div>

                                        <div className={styles.loginInputGroup}>
                                            <label>State</label>
                                            <select
                                                name="billingAddress.state"
                                                className={styles.selectField}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.billingAddress.state}
                                                disabled={!formik.values.billingAddress.country}
                                            >
                                                <option value="">Select</option>
                                                {billingStates?.map((state) => (
                                                    <option key={state?.isoCode} value={state?.name}>
                                                        {state?.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {formik.touched.billingAddress?.state && formik.errors.billingAddress?.state ? (
                                                <div className={styles.error}>{formik.errors.billingAddress.state}</div>
                                            ) : null}
                                        </div>

                                        <div className={styles.loginInputGroup}>
                                            <label>Zip Code</label>
                                            <input
                                                type="text"
                                                name="billingAddress.zipCode"
                                                placeholder="Enter Zip code"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.billingAddress.zipCode}
                                            />
                                            {formik.touched.billingAddress?.zipCode && formik.errors.billingAddress?.zipCode ? (
                                                <div className={styles.error}>{formik.errors.billingAddress.zipCode}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
                                        <input type="checkbox" name="" id="" onChange={() => dispatch(setAddress())} checked={sameAddress} /> Same as Billing Address
                                    </div>
                                    <p>Shipping Address</p>
                                    <div className={styles.loginFormRow1}>
                                        <div className={styles.loginInputGroup}>
                                            <label>Factory Units</label>
                                            <select
                                                name="shippingAddress.factoryUnits"
                                                className={styles.selectField}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.shippingAddress.factoryUnits}
                                                disabled={sameAddress}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>
                                            {formik.touched.shippingAddress?.factoryUnits && formik.errors.shippingAddress?.factoryUnits ? (
                                                <div className={styles.error}>{formik.errors.shippingAddress.factoryUnits}</div>
                                            ) : null}
                                        </div>
                                        <div className={styles.loginInputGroup2}>
                                            <label>Street Address</label>
                                            <input
                                                type="text"
                                                name="shippingAddress.streetAddress"
                                                placeholder="Enter shipping street address"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.shippingAddress.streetAddress}
                                                disabled={sameAddress}
                                            />
                                            {formik.touched.shippingAddress?.streetAddress && formik.errors.shippingAddress?.streetAddress ? (
                                                <div className={styles.error}>{formik.errors.shippingAddress.streetAddress}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className={styles.loginFormRow2}>
                                        <div className={styles.loginInputGroup}>
                                            <label>Country / Region</label>
                                            <select
                                                name="shippingAddress.country"
                                                className={styles.selectField}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.shippingAddress.country}
                                                onChange={(e) => handleShippingCountryChange(e.target.value)}
                                                disabled={sameAddress}
                                            >
                                                <option value="">Select</option>{countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {formik.touched.shippingAddress?.country && formik.errors.shippingAddress?.country ? (
                                                <div className={styles.error}>{formik.errors.shippingAddress.country}</div>
                                            ) : null}
                                        </div>

                                        <div className={styles.loginInputGroup}>
                                            <label>State</label>
                                            <select
                                                name="shippingAddress.state"
                                                className={styles.selectField}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.shippingAddress.state}
                                                disabled={!formik.values.shippingAddress.country || sameAddress}
                                                
                                            >
                                                <option value="">Select</option>
                                                {shippingStates?.map((state) => (
                                                    <option key={state?.isoCode} value={state?.name}>
                                                        {state?.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {formik.touched.shippingAddress?.state && formik.errors.shippingAddress?.state ? (
                                                <div className={styles.error}>{formik.errors.shippingAddress.state}</div>
                                            ) : null}
                                        </div>

                                        <div className={styles.loginInputGroup}>
                                            <label>Zip Code</label>
                                            <input
                                                type="text"
                                                name="shippingAddress.zipCode"
                                                placeholder="Enter Zip code"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.shippingAddress.zipCode}
                                                disabled={sameAddress}
                                            />
                                            {formik.touched.shippingAddress?.zipCode && formik.errors.shippingAddress?.zipCode ? (
                                                <div className={styles.error}>{formik.errors.shippingAddress.zipCode}</div>
                                            ) : null}
                                        </div>
                                    </div>


                                    <div className={styles.loginAccLinks}>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <button type="button" className={styles.loginButtonStroke} onClick={() => navigate(-1)}>Back</button>
                                            <button type="submit" className={styles.loginButton} onClick={formik.handleSubmit}>
                                                {formik.isSubmitting ? 'Please wait...' : 'Register'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerBillingAddress;
